// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:44:44

export default {
  "id": "cute-relaxing-matching-3-tiles",
  "slug": "cute-relaxing-matching-3-tiles",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/6a09b4a2d2674f95b79f4f209affa1af-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/6a09b4a2d2674f95b79f4f209affa1af/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Cute Relaxing Matching 3 Tiles",
      "description": "Fun Farm Wonderland is a light but extremely fun game from our team\n\nFun Farm Wonderland is a puzzle game combined with a Farm theme, to create a feeling of lightness and relaxation for all players participating in them.\n\nHave you ever played a match 3 tiles game with such cute design and interface? If not, don't skip our game, for the following reasons",
      "instructions": "Use your mouse to play and make the match 3",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "1player"
      ]
    },
    "zh-CN": {
      "title": "可爱放松匹配3块拼图",
      "description": "欢乐农场奇境是我们团队制作的一款轻松但极富乐趣的游戏。\n\n欢乐农场奇境是一款结合农场主题的益智游戏，旨在为所有参与游戏的玩家带来轻松和放松的感觉。\n\n你有没有玩过如此可爱设计和界面的三消拼图游戏？如果没有，请不要错过我们的游戏，以下是一些理由：",
      "instructions": "使用鼠标进行游戏，进行三消匹配",
      "genres": [
        "三消匹配"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "zh-TW": {
      "title": "可愛放鬆配對3格拼圖",
      "description": "趣農場奇境是一個我們團隊推出的輕鬆卻極具趣味性的遊戲。\n\n趣農場奇境是一款結合農場主題的益智遊戲，為所有參與遊戲的玩家帶來輕鬆與放鬆的感覺。\n\n你曾經玩過這樣可愛設計與介面的三消拼圖遊戲嗎？如果沒有，請不要跳過我們的遊戲，以下為以下幾個原因：",
      "instructions": "使用滑鼠遊戲並完成三消配對",
      "genres": [
        "配對3"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "zh-HK": {
      "title": "可愛放鬆配對3格 tile",
      "description": "Fun Farm Wonderland 是我們團隊推出的一個輕鬆但又極具趣味性的遊戲\n\nFun Farm Wonderland 是一款結合農場主題的益智遊戲，為所有參與遊戲的玩家帶來輕鬆放鬆的感覺。\n\n你曾經玩過如此可愛的設計和介面的三消遊戲嗎？如果沒有，請不要跳過我們的遊戲，以下是以下幾個原因：",
      "instructions": "使用鼠標操作遊戲並進行三顆一組對齊",
      "genres": [
        "三消對戰"
      ],
      "tags": [
        "1人玩家"
      ]
    },
    "ja": {
      "title": "可愛でリラックスできるマッチング3タイル",
      "description": "ファンファームワンダーランドは、私たちのチームから出た軽いけど非常に楽しいゲームです\n\nファンファームワンダーランドは、パズルゲームと農場のテーマを組み合わせて、参加する全てのプレイヤーに軽やかでリラックスできる雰囲気を作り出すゲームです。\n\nこんな可愛いデザインやインターフェースを持つマッチ3タイルゲームを遊んだことがありますか？もしまだ遊んでいないのなら、以下の理由で私たちのゲームをスキップしないでください。",
      "instructions": "マウスを使って遊び、マッチ3を達成してください",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "1プレイヤー"
      ]
    },
    "ko": {
      "title": "취급하게 하는 여유로운 매칭 3 타일",
      "description": "퀸 파크 원더랜드는 우리 팀의 가벼운 하지만 매우 흥미로운 게임입니다.\n\n퀸 파크 원더랜드는 파크 테마와 결합된 패uzzle 게임으로, 모든 참여자들에게 가벼움과 편안함을 느끼게 합니다.\n\n이렇게 귀여운 디자인과 인터페이스를 가진 매치 3 타일 게임을 찾아보셨나요? 아니라면, 다음 이유로 우리 게임을 놓치지 마세요.",
      "instructions": "마우스를 사용하여 게임을 플레이하고 3개의 모양을 일치시켜주세요.",
      "genres": [
        "매치3"
      ],
      "tags": [
        "1플레이어"
      ]
    },
    "fr": {
      "title": "Merveilleux Mosaïque Relaxante 3 Carrés",
      "description": "Le Fun Farm Wonderland est un jeu léger mais extrêmement amusant de notre équipe.\n\nLe Fun Farm Wonderland est un jeu de puzzle combiné à un thème de ferme, créant un sentiment de légèreté et de relaxation pour tous les joueurs y participant.\n\nAvez-vous déjà joué à un jeu de cartes à trois en alignement avec un design et une interface si mignons ? Si ce n'est pas le cas, ne passez pas à côté de notre jeu, pour les raisons suivantes :",
      "instructions": "Utilisez votre souris pour jouer et faire correspondre 3 éléments.",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "1 joueur"
      ]
    }
  }
};
